/**
 * Client-side derived KPI expressions for OPTION metrics.
 *
 * A filtered view of the generated calculation registry (see
 * derivedKpiExpressions.generated.ts, compiled from the backend's
 * derived_kpi_expressions.py) — no longer a hand-maintained mirror.
 *
 * Only weekly-only metrics (the OPTION_* family) are exposed: they are the
 * ones the grid computes client-side, selected by the same `weeklyOnly` flag
 * the server's evaluator uses. Other registry entries (per-SQM,
 * sales-derived) are served by the backend or handled by dedicated value
 * getters and must not classify as option-derived. The registry is
 * topologically sorted, so iterating this object in insertion order resolves
 * chained dependencies in one pass.
 */

import {
  DERIVED_KPI_EXPRESSIONS,
  type GeneratedDerivedExpression
} from "./derivedKpiExpressions.generated";

export const OPTION_DERIVED_EXPRESSIONS: Record<
  string,
  GeneratedDerivedExpression
> = Object.fromEntries(
  Object.entries(DERIVED_KPI_EXPRESSIONS).filter(
    ([, expression]) => expression.weeklyOnly
  )
);
